export default "__VITE_ASSET__DVqVba0j__"